import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { cn } from '../lib/utils';

interface ThemeLogoProps {
  className?: string;
  alt?: string;
}

export const ThemeLogo: React.FC<ThemeLogoProps> = ({ 
  className, 
  alt = "44Agents logo" 
}) => {
  const { actualTheme } = useTheme();
  
  // Use white logo in dark mode, regular logo in light mode
  const logoSrc = actualTheme === 'dark' ? '/44logo-w.svg' : '/44logo.svg';
  
  return (
    <img 
      src={logoSrc} 
      alt={alt} 
      className={cn("h-8 w-auto", className)} 
    />
  );
};
